import { Reveal } from "@/components/motion";

export default function PageHd({ eb, h, p, testid }) {
  return (
    <div className="pagehd wrap">
      <Reveal>
        <div className="eyebrow">{eb}</div>
        <h1 data-testid={testid}>{h}</h1>
        {p && <p className="lede" style={{ margin: "0 auto" }}>{p}</p>}
      </Reveal>
    </div>
  );
}
